import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import cookieCutter from 'cookie-cutter';
import axios from 'axios';

import { SECTION_LIST_PAGE_LIMIT } from '../../../common/constants/number';
import { toFit } from '../../../hooks/useToFit';
import Slider from '../carousel/Slider';

export default function myvod (props) {
  const router = useRouter();
  const { pageSection: section, category = '', sort = '' } = router.query;
  const [pageQueryParams, setPageQueryParams] = useState({ section, category, sort, offset: 0, limit: SECTION_LIST_PAGE_LIMIT });
  const [sectionDataList, setSectionDataList] = useState([]);

  useEffect(() => {
    window.document.addEventListener('scroll', toFit(doNextPage, {}));

    function doNextPage () {
      if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
        setPageQueryParams(prev => {
          const nextOffset = prev.offset + prev.limit;
          let sectionDataListLength;
          setSectionDataList(sPrev => {
            sectionDataListLength = sPrev.length;
            return sPrev;
          });

          if (sectionDataListLength === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    const lginJWT = cookieCutter.get('LOGIN_JWT');
    const config = {
      method: 'get',
      url: process.env.NEXT_PUBLIC_API_MAIN_MYVOD,
      params: { 'jwt-token': lginJWT }
    };

    axios(config).then(function (response) {
      const addList = [];

      for (let i = 0; i < response.data.length; i++) {
        const element = response.data[i];

        const item = {
          title: element.title,
          pgm_nm: element.title,
          link_url: element.link_url,
          pgm_img_url: element.pgm_img_url,
          m_img_url: element.m_img_url
        };
        addList.push(item);
      }

      if (addList.length > 0) {
        setSectionDataList(addList); // 최종적으로 통신에서 불러온 데이터를 list 에서 담는 부분
      } else {
        setSectionDataList([]);
      }
    }).catch(function (error) {
      console.log(error);
    });
  }, [pageQueryParams]);

  return (
    <div className='main_contents_live'>
      <div className='module_titleline_w' tabindex='0' aria-label='내가 본 프로그램'>
        <h3 className='module_titleline_title'>{props.title}</h3>
      </div>
      <Slider
        view=''
        type='poster'
        data={sectionDataList}
        relate_id=''
        relate_title=''
        relate_title_view_yn=''
        relate_type=''
      />
    </div>
  );
}
